export default {
  header: 'API-Schlüssel',
  subheader: 'API-Schlüssel werden verwendet, um programmatischen Zugriff auf die API von Qmulus zu erhalten.\nJeder Schlüssel erbt automatisch die Berechtigungen Ihres Benutzers und handelt in Ihrem Namen.',
  qmulusApiUrl: 'Qmulus API-URL',
  openApiSpecification: 'OpenAPI-Spezifikation',
};
